import { Generator } from "@prisma/internals";
import { ConnectorType, IDMMF } from "@prisma/studio-common";
import { PrismaClientPath } from "./paths";

export type PreviewFeatures = string[];

type GetDMMFOptions = {
  generator: Generator;
  forceBinary: boolean;
  forceLibrary: boolean;
  paths: {
    prismaClient: PrismaClientPath;
  };
};

export function getDMMF({
  generator,
  forceBinary,
  forceLibrary,
  paths,
}: GetDMMFOptions): {
  dmmf: IDMMF;
  datasourceProvider: ConnectorType;
  previewFeatures: PreviewFeatures;
} {
  const {
    externalToInternalDmmf,
  } = require(`${paths.prismaClient}/generator-build/index.js`);
  const dmmf = externalToInternalDmmf(generator.options!.dmmf); // ! is fine, I've never seen a generator without options, YOLO

  const datasourceProvider =
    generator.options!.datasources?.[0]?.activeProvider; // ! is fine, I've never seen a generator without options, YOLO
  if (!datasourceProvider) {
    throw new Error(
      "Could not find a `datasource` declaration in your Prisma Schema. Please declare one, then try again. Read more about the Prisma Schema: https://pris.ly/prisma-schema"
    );
  }

  let previewFeatures = generator.config.previewFeatures || [];
  if (forceLibrary) {
    !previewFeatures.includes("nApi") && previewFeatures.push("nApi");
  } else if (forceBinary) {
    previewFeatures = previewFeatures.filter(p => p !== "nApi");
  }

  return {
    dmmf,
    datasourceProvider,
    previewFeatures,
  };
}
